import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6534a83a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timeIconTime" }
const _hoisted_2 = {
  key: 0,
  class: "depart"
}
const _hoisted_3 = { class: "srOnly" }
const _hoisted_4 = {
  key: 0,
  class: "delayedTime"
}
const _hoisted_5 = { class: "srOnly" }
const _hoisted_6 = {
  key: 2,
  class: "arrive"
}
const _hoisted_7 = { class: "srOnly" }
const _hoisted_8 = { class: "srOnly" }
const _hoisted_9 = {
  key: 0,
  class: "delayedTime"
}
const _hoisted_10 = { class: "srOnly" }

import { formatInTimeZone } from 'date-fns-tz';
import { Skeletor } from 'vue-skeletor';
import { timezone } from '../../envVariables';
import { Icon } from '../../Atoms';
import 'vue-skeletor/dist/vue-skeletor.css';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeIconTime',
  props: {
    departureTime: {},
    arrivalTime: {},
    isDelayed: { type: Boolean },
    delayedDepartureTime: {},
    delayedArrivalTime: {},
    isCancelled: { type: Boolean },
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", {
              class: _normalizeClass([{ delayed: _ctx.isDelayed, cancelled: _ctx.isCancelled }, "time"])
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('Departing at')), 1),
              _createTextVNode(" " + _toDisplayString(_unref(formatInTimeZone)(_ctx.departureTime, _unref(timezone), 'HH:mm')), 1)
            ], 2),
            (_ctx.isDelayed && _ctx.delayedDepartureTime)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('Delayed departure time')), 1),
                  _createTextVNode(" " + _toDisplayString(_unref(formatInTimeZone)(_ctx.delayedDepartureTime, _unref(timezone), 'HH:mm')), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_unref(Skeletor), { key: 1 }))
          : _createCommentVNode("", true),
      _createVNode(_unref(Icon), { "icon-name": "arrowRight" }),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("p", {
              class: _normalizeClass([{ delayed: _ctx.isDelayed, cancelled: _ctx.isCancelled }, "time"])
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('Arriving at')), 1),
              _createTextVNode(" " + _toDisplayString(_unref(formatInTimeZone)(_ctx.arrivalTime, _unref(timezone), 'HH:mm')), 1)
            ], 2),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.isCancelled ? "is cancelled" : "") + " " + _toDisplayString(_ctx.isDelayed ? "is delayed" : ""), 1),
            (_ctx.isDelayed && _ctx.delayedArrivalTime)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('Delayed arrival time')), 1),
                  _createTextVNode(" " + _toDisplayString(_unref(formatInTimeZone)(_ctx.delayedArrivalTime, _unref(timezone), 'HH:mm')), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_unref(Skeletor), { key: 3 }))
          : _createCommentVNode("", true)
    ])
  ]))
}
}

})